<template lang="pug">
  p
    span.opacity-70 {{ isRegister ? 'Регистрируясь' : 'Авторизуясь'}}, вы соглашаетесь с&nbsp;
    router-link.ui-primary--text(
      target="_blank"
      :to="$conf.USER_AGREEMENT"
    ) Правилами&nbsp;
    span.opacity-70 и&nbsp;
    router-link.ui-primary--text(
      target="_blank"
      :to="$conf.PRIVACY_POLICY"
    ) Политикой конфиденциальности
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvBtn,
  },
  props: {
    isRegister: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  methods: {
  },
};
</script>
